import {
  Button,
  Heading,
  Input,
  Link,
  Text,
  Textarea,
} from '@/theme/components';
import { PROMO_BANNER_OFFSET_PX } from '@/config/promoBanner';
import { colors, typography } from '@/theme/foundations';

const promoBannerOffset = `${PROMO_BANNER_OFFSET_PX}px`;

export const theme = {
  styles: {
    global: {
      ':root': {
        '--promo-banner-offset': `0px`,
      },
      'html[data-promo-active="true"]': {
        '--promo-banner-offset': promoBannerOffset,
      },
      '.promo-banner': {
        display: `none`,
      },
      'html[data-promo-active="true"] .promo-banner': {
        display: `block`,
      },
      'html, body': {
        background: `#FBF8F5`,
        minWidth: `280px`,
      },
      body: {
        fontFamily: `Quicksand, sans-serif`,
        color: `gray.700`,
        background: `linear-gradient(180deg, #FBF8F5 0%, #F6F1EC 100%)`,
      },
      '::selection': {
        background: `rgba(243, 146, 0, 0.22)`,
      },
      a: {
        textDecoration: `none`,
      },
    },
  },
  // Structure plate pour que Chakra résolve les tokens (theme.colors.primary.purple, etc.)
  colors: colors.colors,
  ...typography,
  components: {
    Button,
    Heading,
    Input,
    Link,
    Text,
    Textarea,
  },
};
